/** Phone bottom tab bar: Mijn planning · Projecten · Team · Meer. */
import clsx from 'clsx';
import { Ellipsis } from 'lucide-react';
import { NavLink, useLocation } from 'react-router';
import styles from './AppShell.module.css';
import { TAB_PATHS, type NavItem } from './nav.js';

export function TabBar({ items, moreActive, onMore }: { items: readonly NavItem[]; moreActive: boolean; onMore: () => void }) {
  const { pathname } = useLocation();
  const tabs = TAB_PATHS.map((p) => items.find((i) => i.to === p)).filter((i): i is NavItem => !!i);
  const onTab = tabs.some((t) => pathname === t.to || pathname.startsWith(`${t.to}/`));
  const moreSelected = moreActive || (!onTab && pathname !== '/');

  return (
    <nav className={styles.tabbar} aria-label="Hoofdmenu">
      {tabs.map((t) => (
        <NavLink key={t.to} to={t.to} className={({ isActive }) => clsx(styles.tab, isActive && styles.tabActive)}>
          <t.icon aria-hidden="true" />
          <span>{t.label}</span>
        </NavLink>
      ))}
      <button type="button" className={clsx(styles.tab, moreSelected && styles.tabActive)} onClick={onMore} aria-haspopup="dialog" aria-expanded={moreActive}>
        <Ellipsis aria-hidden="true" />
        <span>Meer</span>
      </button>
    </nav>
  );
}
